import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { EASE } from "./motion";
import { formatPrice } from "@/lib/site";

const PLURAL = { Taglia: "taglie", Colore: "colori", Formato: "formati", Variante: "varianti", Size: "taglie", Color: "colori" };

const optionSummary = (product) =>
  (product.options || []).filter((o) => o.values.length > 1).map((o) => `${o.values.length} ${PLURAL[o.name] || o.name.toLowerCase()}`).join(" · ");

export const PodCard = ({ product, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay: (index % 4) * 0.08, ease: EASE }}
  >
    <Link to={`/prodotto/${product.slug}`} data-testid={`pod-card-${product.slug}`} className="group block">
      <div className="relative aspect-square overflow-hidden bg-ink-2">
        <img src={product.image} alt={product.name} loading="lazy" className="h-full w-full object-cover brightness-90 transition-[transform,filter] duration-700 group-hover:scale-105 group-hover:brightness-100" />
        <span className="absolute left-3 top-3 border border-cream/40 bg-ink px-2 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-cream">{product.badge}</span>
        {product.demo && <span data-testid="pod-demo-chip" className="absolute right-3 top-3 bg-amber-300 px-2 py-1 font-mono text-[10px] uppercase tracking-[0.15em] text-ink">Dati di esempio</span>}
        <span className="absolute bottom-3 right-3 flex h-10 w-10 items-center justify-center rounded-full bg-cream text-ink opacity-0 transition-[opacity,transform] duration-300 group-hover:opacity-100 group-hover:-translate-y-1">
          <ArrowUpRight className="h-4 w-4" />
        </span>
      </div>
      <div className="mt-4 flex items-start justify-between gap-4">
        <div>
          <p className="font-display text-base font-bold uppercase leading-tight transition-colors group-hover:text-acid">{product.name}</p>
          <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-smoke">{optionSummary(product) || product.tagline}</p>
        </div>
        <span data-testid={`pod-price-${product.slug}`} className="shrink-0 font-mono text-sm text-cream">{formatPrice(product.price)}</span>
      </div>
    </Link>
  </motion.div>
);
